'use client';

import { useUser } from '@clerk/nextjs';
import { Spacing } from '@ghosts-inc/design-system/constants';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { useRouter } from 'next/navigation';
import Link from '@/components/Link';
import { useAcknowledgeTermsAndConditions } from '../_hook/useAcknowledgeTermsAndConditions';

export const AcknowledgeCheckboxLabel = (props: TypographyProps) => {
  return (
    <Typography
      variant="bodySmallLight"
      color="typographyDarkSecondary"
      textAlign="center"
      {...props}
    >
      I have read and agree to the{' '}
      <Link href="https://www.ghst.io/terms-of-use" target="_blank">
        Terms and Conditions
      </Link>{' '}
      and{' '}
      <Link href="https://www.ghst.io/privacy-policy" target="_blank">
        Privacy Policy
      </Link>
      .
    </Typography>
  );
};

export const Footer = () => {
  const { user } = useUser();
  const router = useRouter();
  const { isAcknowledged, isLoading, onSubmit, handleCheckboxChange } =
    useAcknowledgeTermsAndConditions({
      user,
      onSuccessCallback: () => router.push('/'),
    });

  return (
    <Stack
      alignItems="center"
      borderTop={1}
      borderColor="lightBorder.default"
      bottom={0}
      gap={Spacing.large}
      position="sticky"
      px={Spacing.base}
      py={{ mobile: Spacing.base, tablet: Spacing.large }}
      bgcolor="white"
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={isAcknowledged}
            data-testid="acknowledge-checkbox"
            name="acknowledge-checkbox"
            onChange={handleCheckboxChange}
          />
        }
        label={<AcknowledgeCheckboxLabel />}
      />
      <Button onClick={onSubmit} disabled={!isAcknowledged} loading={isLoading}>
        I agree to the terms & conditions
      </Button>
    </Stack>
  );
};
